import type { LayoutLoad } from './$types';

export const load: LayoutLoad = async () => {
	return {};
};

// export const prerender = false;
// export const ssr = false;
